import { css } from 'styled-components';

export interface WithZIndexProps {
  zIndex?: number;
}

export const withZIndexCSS = ({ zIndex }: WithZIndexProps) => css`
  ${zIndex && `z-index: ${zIndex};`}
`;
